export const drinkData = {
    coffee: [
        {
            item: "Drip",
            twelvePrice: "$2.50",
            sixteenPrice: "$3.00",
        },
        {
            item: "Iced",
            twelvePrice: "$3.75",
            sixteenPrice: "$4.50",
        },
        {
            item: "Cold Brew",
            twelvePrice: "$3.95",
            sixteenPrice: "$4.95",
        },
        {
            item: "Americano",
            twelvePrice: "$3.25",
            sixteenPrice: "$3.95",
        }
    ],
    lattes: [
        {
            item: "Caramel",
            twelvePrice: "$4.75",
            sixteenPrice: "$5.25",
        },
        {
            item: "Hazelnut",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Matcha",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Snickerdoodle",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Vanilla",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Sugar Free Vanilla",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Mocha",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Chai",
            twelvePrice: "*",
            sixteenPrice: "*",
        }
    ],
    specialLattes: [
        {
            item: "Honey Vanilla Almond",
            twelvePrice: "$5.75",
            sixteenPrice: "$6.50",
        },
        {
            item: "Almond Joyous",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
        {
            item: "Hazelnut Mocha",
            twelvePrice: "*",
            sixteenPrice: "*",
        },
    ],
    addOns: [
        {
            item: "Extra Shot",
            price: "$1.00"
        },
        {
            item: "Extra Syrup",
            price: "¢.50"
        },
        {
            item: "Non-Dairy Milk",
            price: "¢.75"
        },
        
    ]
}